import React, { useState, useEffect, Fragment } from 'react';
import { TextField, Box, Button, CircularProgress, Typography, Card, CardActions, CardContent, CardHeader, DateTime } from '@mui/material';

import { useNotify } from 'react-admin'
import client from '../common/client';
import Help from '../component/Help'

const ProjectFrontS3Create = props => {
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [disabled, setDisabled] = React.useState(false);
    const [name, setName] = React.useState('');

    const create = (e) => {
        setLoading(true)
        client.request_post(`/api/distribution/s3/create`, {
            project_id:props.project_id,
            s3_bucket:props.s3,
            private:props.private,
        }).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Creation Success`);
                update()
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    useEffect(() => {
        update()
    }, [props.s3, props.project_id])

    const update = () => {
        if(props.s3) {
            setLoading(true)
            setDisabled(true)
            client.request_get(`/api/distribution/s3/get/${props.project_id}/${props.s3}`).then(res => {
                setLoading(false)
                if(res) {
                    if(res.exists) {
                        setDisabled(true)
                        setName('Already Created')
                    } else {
                        setDisabled(false)
                        setName('Create')
                    }
                }
            })
        } else {
            setDisabled(true)
            setName('None')
        }
    }
    return (
        <Button variant="contained" color="primary" disabled={loading || disabled}  startIcon={loading && <CircularProgress size={24} />} onClick={create}>
                            {name}</Button>
    );
};

export default ProjectFrontS3Create;
